import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a18c3198"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "page-title" }, "Édition de propriété personnalisée", -1))
const _hoisted_2 = { class: "form-container" }
const _hoisted_3 = { class: "test" }

import ApiService from "@/_services/api.service";
import swal from "@/_helpers/swal";
import router from "@/router";
import { ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import CustomButton from "@/components/forms/CustomButton.vue";

const addNewValueLabel = "Ajouter une valeur";


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomPropertiesEdit',
  setup(__props) {

const route = useRoute();
const propertyData = ref({
  uuid: "",
  name: "",
  values: [
    {value: ""}
  ],
});
function checkDuplicateName(node){
 return propertyData.value.values.filter((property)=>property.value.toLowerCase() === node.value.toLowerCase()).length === 1
}
onMounted(async () => {
  const propertyUuid = route.params.uuid;
  await fetchPropertyData(propertyUuid);
});

const fetchPropertyData = async (propertyUuid) => {
  try {
    const response = await ApiService.get("/properties/" + propertyUuid);

    propertyData.value.uuid = response.data.data.uuid;
    propertyData.value.name = response.data.data.name;
    propertyData.value.values = response.data.data.propertyValues.map((value) => ({
      uuid: value.uuid,
      value: value.value,
    }));
  } catch (error) {
  }
};

const submitHandler = (data, formNode) => {
  const propertyUuid = propertyData.value.uuid;
  data.uuid = propertyUuid;
  return ApiService.put(`/properties/${propertyUuid}`, data)
    .then(({ data }) => {
      swal.success("Propriété mise à jour !", "");
      router.push({ name: 'customPropertiesList' });
    })
    .catch(({response}) => {
      response.data.errors.forEach((error) => {
        let field = error.property;
        if (field) {
          field = field.replace('[', '.');
          field = field.replace(']', '');
          formNode.setErrors(
            null,
            {
              [field]: error.message
            }
          );
        }
        return false;
      });
      swal.error("Erreur lors de la modification de la propriété");
    });
};

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CustomButton, {
      to: { name: 'customPropertiesList' },
      label: "Links.goBack"
    }),
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_FormKit, {
        type: "form",
        onSubmit: submitHandler,
        actions: false,
        "incomplete-message": "Désolé, tous les champs ne sont pas remplis correctement.",
        model: propertyData.value
      }, {
        default: _withCtx(() => [
          _createVNode(_component_FormKit, {
            type: "text",
            name: "name",
            label: "Propriété",
            placeholder: "Modifier le nom de la propriété",
            validation: "required|length:1,50",
            "validation-messages": {
          required: 'Ce champ est obligatoire.',
          length: 'Ce champ doit contenir maximum 50 caractères.',
        },
            modelValue: propertyData.value.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((propertyData.value.name) = $event))
          }, null, 8, ["validation-messages", "modelValue"]),
          _createVNode(_component_FormKit, {
            id: "repeater",
            name: "values",
            type: "repeater",
            label: "Valeurs de la propriété",
            "add-label": addNewValueLabel,
            min: "1",
            modelValue: propertyData.value.values,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((propertyData.value.values) = $event))
          }, {
            default: _withCtx(({ index }) => [
              _createVNode(_component_FormKit, {
                type: "text",
                label: `${index + 1}. Valeur`,
                name: "value",
                validation: "required|length:1,50|checkDuplicateName",
                "validation-rules": {checkDuplicateName: checkDuplicateName},
                placeholder: "Modifier une valeur",
                "validation-messages": {
            required: 'Ce champ est obligatoire.',
            length: 'Ce champ doit contenir maximum 50 caractères.',
            checkDuplicateName:'Cette valeur existe déjà.'
          }
              }, null, 8, ["label", "validation-rules", "validation-messages"])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_FormKit, {
              type: "submit",
              label: "Mettre à jour"
            })
          ])
        ]),
        _: 1
      }, 8, ["model"])
    ])
  ], 64))
}
}

})